import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, MenuItem, Stack, TextField, Alert } from '@mui/material';
import { useAuth } from '../auth/AuthProvider';
import { roleLabels } from '../configs/profile';
import { t } from '../i18n';

export default function AccessSelectionForm({ onSelected, onCancel, warnOnSwitch = false }) {
    const { roles, clinics, role, selectAccess } = useAuth();
    const defaultClinic = role?.account.uuid || (clinics.length === 1 ? clinics[0].uuid : '');
    const defaults = roles.filter((candidate) => candidate.account.uuid === defaultClinic);
    const [clinicUuid, setClinicUuid] = useState(defaultClinic);
    const [roleUuid, setRoleUuid] = useState(role?.uuid || (defaults.length === 1 ? defaults[0].uuid : ''));
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(false);
    const availableRoles = roles.filter((candidate) => candidate.account.uuid === clinicUuid);
    const valid = availableRoles.some((candidate) => candidate.uuid === roleUuid);
    const submit = async (event) => {
        event.preventDefault();
        if (!valid || busy) return;
        setBusy(true);
        setError(false);
        try {
            await selectAccess(roleUuid, clinicUuid);
            onSelected();
        } catch {
            setError(true);
        } finally {
            setBusy(false);
        }
    };
    return (
        <Stack component="form" onSubmit={submit} spacing={2.5} sx={{ pt: 1 }}>
            {warnOnSwitch && <Alert severity="info">{t('Ao mudar de contexto, as alterações não guardadas serão descartadas.')}</Alert>}
            <TextField select fullWidth label={t('Clínica')} value={clinicUuid} disabled={busy}
                onChange={(event) => {
                    const nextClinic = event.target.value;
                    const nextRoles = roles.filter((candidate) => candidate.account.uuid === nextClinic);
                    setClinicUuid(nextClinic);
                    setRoleUuid(nextRoles.length === 1 ? nextRoles[0].uuid : '');
                }}>
                {clinics.map((clinic) => <MenuItem key={clinic.uuid} value={clinic.uuid}>{clinic.name || t('Clínica')}</MenuItem>)}
            </TextField>
            <TextField select fullWidth label={t('Perfil de acesso')} value={roleUuid} disabled={busy || !clinicUuid}
                onChange={(event) => setRoleUuid(event.target.value)}>
                {availableRoles.map((candidate) => <MenuItem key={candidate.uuid} value={candidate.uuid}>
                    {t(roleLabels[candidate.name] || candidate.name)}
                </MenuItem>)}
            </TextField>
            {error && <Alert severity="error">{t('Não foi possível selecionar o acesso. Tente novamente.')}</Alert>}
            <Stack direction="row" spacing={1.5} justifyContent="flex-end">
                {onCancel && <Button type="button" disabled={busy} onClick={onCancel}>{t('Cancelar')}</Button>}
                <Button type="submit" variant="contained" disabled={busy || !valid}>{t(busy ? 'Aguarde…' : 'Continuar')}</Button>
            </Stack>
        </Stack>
    );
}

AccessSelectionForm.propTypes = {
    onSelected: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    warnOnSwitch: PropTypes.bool
};
